import {useRef, useState} from 'react';
import globalDomains from '@/utils/global-domains';
import MyProfileImg from '@/components/my/common/item/MyProfileImg';
import {SoopUiProfileIconMenu} from '@/components/ui';
import {useOutsideClick} from '@/components/main/common/hooks/useOutsideClick';
import {convertViewCnt} from '@/utils/main';

/**
 * 별별랭킹 PC 레이아웃 상단 스위퍼 내부 아이템의 방송 정보 영역
 */
const StarRankSwiperDetailMenu = ({rankItem, onMenuVisibilityChanged}) => {
  const soopUiProfileIconMenuRef = useRef(null);

  const [isMenuVisible, setIsMenuVisible] = useState(false);

  /**
   * 스트리머 닉네임 영역 클릭 시 SoopUiProfileIconMenu 표출
   * @param {*} e
   * @returns
   */
  const handleOnStreamerNickNameClicked = (e) => {
    //a Tag 클릭막기
    e.preventDefault();

    soopUiProfileIconMenuRef.current?.open();

    // 메뉴가 표시됐음을 알린다.
    onMenuVisibilityChanged(true);
    setIsMenuVisible(true);

    return false;
  };

  /**
   * 메뉴 외부 영역이 클릭됐을 시 메뉴의 visible 여부를 변경
   */
  useOutsideClick(
    soopUiProfileIconMenuRef,
    () => {
      /**
       * Note. SoopUiProfileIconMenu에서 어차피 useOutsideClick을 이미 쓰고 있는데
       * 왜 이렇게 번거롭게 직접 useOutsideClick을 또 사용해서 ref를 조작하느냐.
       * 가능한 한 SoopUiProfileIconMenu의 인터페이스를 변경하지 않고
       * 메뉴가 닫혔을 때의 이벤트를 발생시키고 싶었음.
       */

      // 메뉴가 표시 해제됐음을 알리고 메뉴를 닫는다.
      onMenuVisibilityChanged(false);
      setIsMenuVisible(false);
      soopUiProfileIconMenuRef.current?.close();
    },
    isMenuVisible,
  );

  /**
   * Note: 아무것도 안하지만 이벤트 핸들러를 전달하지 않을 경우 SoopUiProfileIconMenu에서 에러 발생
   * @param {*} event
   */
  const handleProfileIconMenuClicked = (event) => {};

  return (
    <div className='details'>
      <a
        href={`${globalDomains.BJ_AFREECATV}/${rankItem?.userId}`}
        className='thumb'
        target='_blank'>
        <MyProfileImg userId={rankItem?.userId} disableLazy={true} />
      </a>
      <a className='nick' target='_blank'>
        <span onClick={handleOnStreamerNickNameClicked}>
          {rankItem?.userNick}
        </span>
      </a>
      <span className='views'>
        <em>{convertViewCnt(rankItem?.totalViewCnt)}명 참여중</em>
      </span>
      <SoopUiProfileIconMenu
        ref={soopUiProfileIconMenuRef}
        streamerId={rankItem?.userId}
        streamerNick={rankItem?.userNick}
        handleMenuButtonClicked={handleProfileIconMenuClicked}
      />
    </div>
  );
};

export default StarRankSwiperDetailMenu;
